module.exports = __webpack_public_path__ + "img/Frame8731@2x.a92b14ae.png";